import React, { useContext, useEffect, useState } from "react";
import { Navigate} from "react-router-dom";
import { AppContext } from '../../App';


const Logout = () => {
    const context = useContext(AppContext);

    useEffect(() => {
        console.log(context)
        console.log(sessionStorage.getItem('osuwmc_set_shibkey'))
        if(context !== null) {
            handleLogout()
        }
    }, []);

    const handleLogout = (e) => {
        console.log('logging out')
        context.updateContext(null);
        sessionStorage.removeItem('osuwmc_set_shibkey');
        window.location.href = "https://webauth.service.ohio-state.edu/cgi-bin/logout.cgi" ;
    }

    if(sessionStorage.getItem('osuwmc_set_shibkey') === null) {
        return (<><div className="help-block">You Have Successfully Logged Out</div></>);
    } else {
        if (context.authenticateAgency === "OSU") {
            return (<><div className="help-block">OSU logout in progress ...</div></>);
        }
        else {
            if (!context.isAuthenticated) {
                return (<Navigate to='/Login' replace={true} />);
            } else {
                return (<button className="btn btn-primary" onClick={handleLogout}>Log Out</button>);
            }
        }
    }

};

export default Logout;